/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adr_SetupInputs */



/**
* | output |
* | --- |
* | "ADR Setup" |
*
* @param {Adr_SetupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const adr_setup = /** @type {((inputs?: Adr_SetupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adr_SetupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configuration ADR")
	if (locale === "de") return /** @type {LocalizedString} */ ("ADR-Einrichtung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configurazione ADR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройка ADR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de ADR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ADR设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADRの設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडीआर सेटअप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configuração de ADR")
	return /** @type {LocalizedString} */ ("ADR Setup")
});